import React from "react";
import { DatePicker, Tooltip } from "antd";
import dayjs from "dayjs";
import { BellFilled } from "@ant-design/icons";
import { ChantCheckbox, ChantButton } from "../../../../../../CommonComponents";
import DefaultSettingsImage from "../../../../../../images/Chant_Event_Default_Settings.png";
import { normalizeTo13Digits } from "../utils/helpers";
import "../styles/eventFormStyles.css";
import useContentFormParams from "../hooks/useContentFormParams";

const { RangePicker } = DatePicker;

export const DisplayAndNotificationsSection = ({
  showOnHomePage,
  showForFans,
  notificationInUtc,
  eventEndDate,
  onShowOnHomePageChange,
  onShowForFansChange,
  onNotificationChange,
  onAddNotification,
}) => {
  const { formMode } = useContentFormParams();
  return (
    <div className="event-form-notification-section">
      <div className="event-form-section-title">Display & Notification</div>

      <div className="event-form-field-group">
        <div
          className="event-form-label"
          style={{
            minWidth: "200px",
            paddingTop: "8px",
            fontSize: "14px",
            fontWeight: "500",
            color: "#333",
            display: "flex",
            alignItems: "center",
          }}
        >
          Show on Home Screen
          <Tooltip
            placement="topLeft"
            title={() => (
              <div style={{ maxWidth: "400px" }}>
                Will show through selected end date
                <img
                  src={DefaultSettingsImage}
                  alt=""
                  style={{ width: "100%", marginTop: "8px" }}
                />
              </div>
            )}
          >
            <span
              style={{
                marginLeft: "6px",
                color: "#8c8c8c",
                cursor: "help",
                fontSize: "16px",
              }}
            >
              <i className="fa fa-question-circle-o" />
            </span>
          </Tooltip>
        </div>
        <div className="event-form-field-wrapper">
          <RangePicker
            value={showOnHomePage}
            onChange={onShowOnHomePageChange}
            disabledDate={(current) =>
              current && current > dayjs.unix(eventEndDate || 9999999999)
            }
            style={{ maxWidth: "400px" }}
            disabled={formMode === "view"}
          />
        </div>
      </div>

      <div className="event-form-field-group">
        <div className="event-form-field-row">
          <div style={{ flex: 1 }}>
            <ChantCheckbox
              checked={showForFans}
              onChange={onShowForFansChange}
              disabled={formMode === "view"}
            >
              <span style={{ fontSize: "14px", color: "#333" }}>
                Show to fans (non-members) in app and website?
              </span>
              <Tooltip
                placement="topLeft"
                title={() => (
                  <div style={{ width: "400px" }}>
                    Checking option will display this event on your Chant
                    website (if used) and to the &quot;fan&quot; role (if
                    allowed in the app).
                  </div>
                )}
              >
                <span
                  style={{
                    marginLeft: "6px",
                    color: "#8c8c8c",
                    cursor: "help",
                    fontSize: "16px",
                  }}
                >
                  <i className="fa fa-question-circle-o" />
                </span>
              </Tooltip>
            </ChantCheckbox>
          </div>
        </div>
      </div>

      <div className="event-form-field-group">
        <div
          className="event-form-label"
          style={{
            fontSize: "14px",
            fontWeight: "500",
            color: "#333",
            marginBottom: "12px",
            display: "flex",
            alignItems: "center",
          }}
        >
          Notifications
          <Tooltip
            placement="topLeft"
            title={() => (
              <div style={{ width: "400px" }}>
                <p style={{ marginBottom: "8px" }}>
                  Important: Will send app notification to all members
                </p>
                <p style={{ marginBottom: "8px" }}>
                  Notifications scheduled for today are sent upon
                  &quot;submit&quot;. Scheduled notifications are sent at 1:00PM
                  ET.
                </p>
                <img
                  src={DefaultSettingsImage}
                  alt=""
                  style={{ width: "100%", marginTop: "8px" }}
                />
              </div>
            )}
          >
            <span
              style={{
                marginLeft: "6px",
                color: "#8c8c8c",
                cursor: "help",
                fontSize: "16px",
              }}
            >
              <i className="fa fa-question-circle-o" />
            </span>
          </Tooltip>
        </div>
        <div className="event-form-notification-grid">
          {notificationInUtc.map((element, index) => {
            const normalizedElement = normalizeTo13Digits(element);
            return (
              <DatePicker
                key={index}
                format="YYYY-MM-DD"
                value={normalizedElement ? dayjs.utc(normalizedElement) : null}
                placeholder="Select date"
                onChange={(value) => onNotificationChange(value, index)}
                disabled={formMode === "view"}
                style={{
                  width: "200px",
                  borderRadius: "4px",
                }}
              />
            );
          })}
          {notificationInUtc.length < 3 && formMode !== "view" && (
            <ChantButton
              type="default"
              onClick={onAddNotification}
              icon={<BellFilled />}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                height: "32px",
                borderRadius: "4px",
              }}
            >
              Add notification
            </ChantButton>
          )}
        </div>
      </div>
    </div>
  );
};
